import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import { useState } from "react";

function LoadingScreen({value}) {
  // console.log(value);
  // eslint-disable-next-line
  const [open, setOpen] = useState(value);

  return (
    <div>
      <Backdrop
        sx={{ color: "#0000FF", backgroundColor: "#fff", width: "100%" }}
        open={open}
      >
        <div
          style={{
            display: "block !important",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <div>
            <img
              style={{ marginLeft: "auto", marginRight: "auto" }}
              src="https://logow.s3.us-west-1.amazonaws.com/lipana_single_logo.png"
              alt=""
            />
          </div>
          <div style={{ marginTop: "10px" }}>
            <Box sx={{ width: "100%" }}>
              <LinearProgress />
            </Box>
          </div>
        </div>
      </Backdrop>
    </div>
  );
}

export default LoadingScreen;
